import forwardApi from "../api/forward.api";

class ForwardService {
    getDefaultModel(forward) {
        if (forward) {
            return { unitId: forward.unitId, urlsSet: new Set(forward.urls), edit: true }
        } else {
            return { unitId: "", urlsSet: new Set(), edit: false };
        }
    }

    async getAll() {
        const result = await forwardApi.getAll();
        return result.sort(this.sortByUnitId);
    }

    sortByUnitId(a, b) {
        if (a.unitId > b.unitId) {
            return 1;
        }
        if (a.unitId < b.unitId) {
            return -1;
        }
        return 0;
    }

    async create(data) {
        const newForward = { unitId: data.unitId };
        newForward.urls = Array.from(data.urlsSet);
        return await forwardApi.create(newForward);
    }

    async update(data) {
        const newForward = { unitId: data.unitId };
        newForward.urls = Array.from(data.urlsSet);
        return await forwardApi.update(newForward);
    }

    async detele(unitId) {
        return await forwardApi.detele(unitId);
    }
}

export default new ForwardService();